module.exports = __webpack_public_path__ + "assets/images/time-last-week-icon.41ff93d6a0d20d0d0784dbf48fb50d2d.svg";